<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="510px">

<v-card>
  <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
  <v-divider></v-divider>
  <v-card-text>

    <v-card flat="" class="white--text">
      <v-card flat="">
        <v-card-actions>
          <v-layout row="" wrap="">
            <!-- <v-flex xs12 v-if="filtreUyari" sm12 md12>

              <v-layout align-start="" justify-start="" fill-height="">
                <v-icon color="red">warning</v-icon> &nbsp;
                <span class="subheading red--text font-weight-bold">
                 {{ $t('continue-with-Apply-Filters-option') }}
                </span>
              </v-layout>
            </v-flex> -->
            <v-flex xs12 sm12 md12>
              <catimuhasebekodu
                    v-model="searchParams.startAccoutingCode"
                    :controlValue="searchParams.startAccoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('Start-Accounting-Code')"
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <catimuhasebekodu
                    v-model="searchParams.endAccoutingCode"
                    :controlValue="searchParams.endAccoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('End-Accounting-Code')"
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-select
          :items="hesapItems"  item-text="ad"
          item-value="id"
          label="Hesaplar" v-model="searchParams.WhichAccounts"
        ></v-select>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-select
          :items="MizanTuru"  item-text="ad"
          item-value="id"
          label="Mizan Türü" v-model="searchParams.Type"
        ></v-select>
            </v-flex>
              <v-flex xs12 sm12 md12>
              <v-autocomplete hide-details="" v-model="searchParams.CostCenterCode" :items="masrafmerkezi"
                          :label="$t('Expense-Center-v2')" item-text="CodeName" clearable item-value="Code" max-height="400">
                        </v-autocomplete> </v-flex>
            <v-flex xs12 sm12 md12>
              <v-checkbox v-model=checked1
      label="Sadece Hareket Görenleri Göster" 
   
    ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm12 md12>
             
              <v-checkbox v-model=checked2
      label="Bakiyesi Sıfır Olanları Göster" 
    ></v-checkbox>
            </v-flex>
          
            <v-flex xs12 sm12 md12>
            
              <v-checkbox
      label="Tek Bakiye" v-model=checked3 
    
    ></v-checkbox>
            </v-flex>
            <v-checkbox v-model=searchParams.ExcludeClosingFiche
      label="Kapanış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
    <v-checkbox v-model=searchParams.ExcludeOpeningFiche
      label="Açılış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{ $t('cancel_button') }} </v-btn>
    <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
  </v-card-actions>
</v-card>


</v-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title> {{ $t("Accounting-Balance") }} </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-container fluid="">
          <v-layout row wrap>
            <v-flex
              xs12
              sm6
              md6
              style="padding-right: 2px; padding-bottom: 4px"
            >
              <v-card color="#1E88E5" class="white--text">
                <v-layout>
                  <v-flex xs2 sm2 md2>
                    <v-layout align-center="" justify-center="" fill-height="">
                      <v-icon color="white" large="">cached</v-icon>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm10 md10>
                    <v-card-title primary-title="">
                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading font-weight-">
                                {{ $t("Total-Credit") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm9 md8>
                            <v-list-tile-title>
                              <span
                                class="subheading font-weight-"
                                v-if="items.length > 0"
                              >
                                :
                                {{ TotalCredit | moneyformat
                                }}{{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading font-weight-">
                                {{ $t("Total-Balance-Receivable") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm9 md8>
                            <v-list-tile-title>
                              <span
                                class="subheading font-weight-"
                                v-if="items.length > 0"
                              >
                                :
                                {{ TotalCreditBalance | moneyformat }}
                                {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex
              xs12
              sm6
              md6
              style="padding-right: 2px; padding-bottom: 4px"
            >
              <v-card color="#1E88E5" class="white--text">
                <v-layout>
                  <v-flex xs2 sm2 md2>
                    <v-layout align-center="" justify-center="" fill-height="">
                      <v-icon color="white" large="">layers</v-icon>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm10 md10>
                    <v-card-title primary-title="">
                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading font-weight-">
                                {{ $t("Total-Debit") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span
                                class="subheading font-weight-"
                                v-if="items.length > 0"
                              >
                                :
                                {{ TotalDept | moneyformat }}
                                {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading font-weight-">
                                {{ $t("Total-Balance-Debt") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span
                                class="subheading font-weight-"
                                v-if="items.length > 0"
                              >
                                :
                                {{ TotalDeptBalance | moneyformat }}
                                {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
            <v-form ref="muhasebehesabagore" v-model="valid">
              <v-layout row wrap="">
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-model="searchParams.FirstDate"
                    v-bind:value="searchParams.FirstDate"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                    v-model="searchParams.EndDate"
                    v-bind:value="searchParams.EndDate"
                  >
                  </tarihcomp>
                </v-flex>
              
                <!-- <v-flex xs12 sm12 md3>
                  <catimuhasebekodu
                    v-model="accoutingCode"
                    :controlValue="accoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="'Muhasebe Kodu'"
                    @validateCheck="checkAccoutingValidate()"
                  >
                  </catimuhasebekodu>
                </v-flex> -->

                <v-flex>
                  <v-layout>
                    <v-btn color="info" @click="getList()" fab small="" dark>
                      <v-icon>search</v-icon>
                    </v-btn>

                    <v-btn small="" @click="filtrele()" color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
            <v-layout>
              <v-flex xs12 sm12 md12 pt-2>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    class="elevation-1"
                    :rows-per-page-items="[50, 100]"
                    :items="items"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <tr :style="props.item.CodeName === 'Genel Toplam:'
    ? 'background-color:#e3f2fd;font-weight:bold'
    : ''">
                      <td class="text-xs-left">
                        {{ props.item.Code }}
                      </td>

                      <td class="text-xs-left">
                        {{ props.item.CodeName }}
                      </td>
 <td class="text-xs-left">
                        {{ props.item.Currency }}
                      </td>
                      <td class="text-xs-right">
                        {{ props.item.Dept | moneyformat }}
                      </td>

                      <td class="text-xs-right">
                        {{ props.item.Credit | moneyformat }}
                      </td>
                      <td class="text-xs-right">
                        {{ props.item.DeptBalance | moneyformat }}
                      </td>

                      <td class="text-xs-right">
                        {{ props.item.CreditBalance | moneyformat }}
                      </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {

      masrafmerkezi:[],
      hesapItems: [
          { ad: 'Tümü', id: 0 },
          { ad: 'Alt Hesaplar', id: 1 },
          { ad: 'Üst Hesaplar', id: 2 },
          { ad: 'Sadece Kebir', id: 3 }
        ],
      dialogfiltre: false,
      search: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      startAccoutingCode:null,
      endAccoutingCode:null,
      checked1: true,
      checked2:true,
      checked3:true,
      searchParams: {
        CompanyID: 0,
        FirstDate: null,
        EndDate: null,
        FirstAccountCode: null,
        EndAccountCode: null,
        ReverseOrder:0,
        Show0Balance:1,
        ListTransactionalAccounts:1,
        WhichAccounts:0,
        SingleBalance:1,
        ExcludeClosingFiche:0,
        ExcludeOpeningFiche:0,
        Type:'0',
        CostCenterCode:""

      },
      MizanTuru:[{
        ad:'Normal',
        id:'0'
      },
    {
        ad:'Dövizli',
        id:'1'
    }],
      accoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      itemDetails: [],
      headers: [
        {
          text: this.$t("Accound-Code"),
          align: "left",
        },
        {
          text: this.$t("Account-Name"),
          align: "left",
        },
         {
          text: this.$t("Döviz"),
          align: "left",
        },
        {
          text: this.$t("Debit"),
          align: "right",
        },
        {
          text: this.$t("Credit"),
          align: "right",
        },
        {
          text: this.$t("Debt-Balance"),
          align: "right",
        },
        {
          text: this.$t("Balance-Receivable"),
          align: "right",
        },
      ],
      TotalCredit: 0,
      TotalCreditBalance: 0,
      TotalDept: 0,
      TotalDeptBalance: 0,
    };
  },
  methods: {
    getExpenseCenters(){
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params = {
                CompanyCode: credentials.SirketKodu
            }
             this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.masrafmerkezi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-ExpenseCenter'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-ExpenseCenter'
                    this.snackbar = true
                }
            })
 
    },
    filtrekayit()
    {
      this.dialogfiltre=false;
      
    },
    filtreiptal()
    {
      this.dialogfiltre=false;
    },
    filtrele()
    {
      this.dialogfiltre=true;
    },
    checkAccoutingValidate() {
      this.accoutingCode.CodeID = 0;
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    getList() {
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);
      if (bastarih <= bittarih) {
        this.items = [];

        if (this.$refs.muhasebehesabagore.validate()) {
          this.loadingvmodel = true;

          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          if (this.searchParams.startAccoutingCode!=null)
          {
            this.searchParams.FirstAccountCode = this.searchParams.startAccoutingCode.Code;
          }
          if (this.searchParams.endAccoutingCode!=null)
          {
            this.searchParams.EndAccountCode = this.searchParams.endAccoutingCode.Code;
          }
          
if (this.checked1)
{
  this.searchParams.ListTransactionalAccounts=1;
}
else
{
  this.searchParams.ListTransactionalAccounts=0;
}

if (this.checked2)
{
  this.searchParams.Show0Balance=1;
}
else
{
  this.searchParams.Show0Balance=0;
}
if (this.checked3)
{
  this.searchParams.SingleBalance=1;
}
else
{
  this.searchParams.SingleBalance=0;
}
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/TrialBalanceList",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                if (response.body.Details.length > -1) {
                  this.items = response.body.Details;
                 if (this.searchParams.Type=="0"){
                    this.TotalCredit = response.body.TotalCredit;
                    this.TotalCreditBalance = response.body.TotalCreditBalance;
                    this.TotalDept = response.body.TotalDept;
                    this.TotalDeptBalance = response.body.TotalDeptBalance;
                    this.items.unshift({Code:'',CodeName:'Genel Toplam:',Currency:'TL',Dept:this.TotalDept,Credit:this.TotalCredit,DeptBalance:this.TotalDeptBalance,CreditBalance:this.TotalCreditBalance});
                    }else{
response.body.TotalsByCurrency.forEach(element => {
    this.items.unshift({Code:'',CodeName:'Genel Toplam:',Currency:element.Currency,Dept:element.TotalDept,Credit:element.TotalCredit,DeptBalance:element.TotalDeptBalance,CreditBalance:element.TotalCreditBalance});
});
                    }
                  this.loadingvmodel = false;
                } else {
                  this.text1 = this.$t("No-Records-Found");
                  this.snackbar = true;
                  this.items = [];
                  this.loadingvmodel = false;
                }
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              }
            );
        }
      } else {
        this.text1 = this.$t("start-date-cannot-greater-than-end-date");
        this.snackbar = true;
      }
    },
    getListHtml() {
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);
      if (bastarih <= bittarih) {
        if (this.$refs.muhasebehesabagore.validate()) {
          this.items = [];
          this.loadingvmodel = true;
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          if (this.searchParams.startAccoutingCode!=null)
          {
            this.searchParams.FirstAccountCode = this.searchParams.startAccoutingCode.Code;
          }
          if (this.searchParams.endAccoutingCode!=null)
          {
            this.searchParams.EndAccountCode = this.searchParams.endAccoutingCode.Code;
          }
          if (this.checked1)
{
  this.searchParams.ListTransactionalAccounts=1;
}
else
{
  this.searchParams.ListTransactionalAccounts=0;
}

if (this.checked2)
{
  this.searchParams.Show0Balance=1;
}
else
{
  this.searchParams.Show0Balance=0;
}
if (this.checked3)
{
  this.searchParams.SingleBalance=1;
}
else
{
  this.searchParams.SingleBalance=0;
}
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/TrialBalanceListHtml",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/html",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "MuhasebeMizan.html";
                link.click();
                this.loadingvmodel = false;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              }
            );
        }
      } else {
        this.text1 = this.$t("start-date-cannot-greater-than-end-date");
        this.snackbar = true;
        this.loadingvmodel = false;
      }
    },
    getListExcel() {
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);
      if (bastarih <= bittarih) {
        this.items = [];
        this.loadingvmodel = true;
        if (this.$refs.muhasebehesabagore.validate()) {
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          if (this.searchParams.startAccoutingCode!=null)
          {
            this.searchParams.FirstAccountCode = this.searchParams.startAccoutingCode.Code;
          }
          if (this.searchParams.endAccoutingCode!=null)
          {
            this.searchParams.EndAccountCode = this.searchParams.endAccoutingCode.Code;
          }
          if (this.checked1)
{
  this.searchParams.ListTransactionalAccounts=1;
}
else
{
  this.searchParams.ListTransactionalAccounts=0;
}

if (this.checked2)
{
  this.searchParams.Show0Balance=1;
}
else
{
  this.searchParams.Show0Balance=0;
}
if (this.checked3)
{
  this.searchParams.SingleBalance=1;
}
else
{
  this.searchParams.SingleBalance=0;
}
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/TrialBalanceListExcel",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
                responseType: "arraybuffer",
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xlsx",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "MuhasebeMizan.xlsx";
                link.click();
                this.loadingvmodel = false;
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                  this.loadingvmodel = false;
                }
              }
            );
        }
      } else {
        this.text1 = this.$t("start-date-cannot-greater-than-end-date");
        this.snackbar = true;
        this.loadingvmodel = false;
      }
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    this.getExpenseCenters();
    if (this.sayfayetki.Status == true) {
      //YETKİ OK
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  },
};
</script>

<style>
</style>

